import React, {Component} from 'react';
import {connect} from 'react-redux';
import {exportData} from '../actions';
import {DATA_SETS, EXPORT_FORMATS} from '../Constants';

class ExportForm extends Component {
  constructor(props) {
    super(props);
    // Local state separate from app state to support edit form.
    this.state = {
      form_open: false,
      format: '',
      include_manual: true,
      starting_day: 1,
      days_lasting: props.short_future ? 2 : 7
    };

    this.handleOpenForm = this.handleOpenForm.bind(this);
    this.handleIncludeManualToggle = this.handleIncludeManualToggle.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.resetVariables = this.resetVariables.bind(this);
  }

  handleOpenForm(event) {
    this.setState({ form_open: true });
    this.resetVariables();
    event.preventDefault();
  }

  handleInputChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ?
                  target.checked :
                  name === 'days_lasting' || name === 'starting_day' ? Number(target.value) : target.value;
    this.setState({
      [name]: value
    });
  }

  handleIncludeManualToggle() {
    this.setState({ include_manual: !this.state.include_manual });
  }

  handleCancel(event) {
    this.setState({ form_open: false });
    this.resetVariables();
    event.preventDefault();
    event.stopPropagation();
  }

  handleSubmit(event) {
    const { format, include_manual, starting_day, days_lasting } = this.state;
    this.props.dispatch(exportData(format, include_manual, starting_day, days_lasting));
    this.setState({ form_open: false });
    event.preventDefault();
    event.stopPropagation();
  }

  resetVariables() {
    const defaultFormat = this.props.data_set === DATA_SETS.ISP ? EXPORT_FORMATS.ISP : EXPORT_FORMATS.PHOENIX;
    this.setState({ format: defaultFormat, include_manual: true });
  }

  render() {
    const { form_open, format, include_manual, starting_day, days_lasting } = this.state;
    const { data_set, short_future } = this.props;
    const length = short_future ? 2 : 7;
    const starting_day_list = Array.from({ length: length }, (v, i) => i + 1);
    const formats = [EXPORT_FORMATS.PHOENIX,
                     EXPORT_FORMATS.WEATHER,
                     EXPORT_FORMATS.DETAILED_WEATHER];
    if (data_set === DATA_SETS.ISP) {
      formats.push(EXPORT_FORMATS.ISP);
    } else if (data_set === DATA_SETS.PRESCRIPTIONS) {
      formats.push(EXPORT_FORMATS.SIMPLE_PLUS_PRESCRIPTIONS);
      formats.push(EXPORT_FORMATS.DETAILED_PLUS_PRESCRIPTIONS);
    } else if (data_set !== DATA_SETS.WEATHER) {
      formats.push(EXPORT_FORMATS.SIMPLE_PLUS_BEHAVIOUR);
      formats.push(EXPORT_FORMATS.DETAILED_PLUS_BEHAVIOUR);
    }

    return <div className="graph-panel-actions">
      <div className="c-button" onClick={this.handleOpenForm} title="Export">
        <i className="fa fa-download"/><label>Export</label></div>
      {form_open &&
       <div className="c-form__export-form-holder">
         <div className="c-form__variables-form">
           <div>
             <label>Format: </label>
             <select name="format" value={format} onChange={this.handleInputChange}>
               {formats.map(f => <option key={f} value={f}>{f}</option>)}
             </select>
           </div>
           <div>
             <label onClick={this.handleIncludeManualToggle}>Include manual changes: </label>
             <input name="include_manual" type="checkbox" checked={include_manual} onChange={this.handleInputChange}/>
           </div>
           <div>
             <label>Starting Day:</label>
             <select onChange={this.handleInputChange} name="starting_day" value={starting_day}
                     style={{ marginRight: '8px' }}>
               {starting_day_list.map(day => <option key={day}>{day}</option>)}
             </select>
             <label>Days to Include:</label>
             <select onChange={this.handleInputChange} name="days_lasting" value={days_lasting}>
               {starting_day_list.reverse().map(day => day - starting_day + 1).filter(d => d > 0).map(d => <option
                 key={d}>{d}</option>)}
             </select>
           </div>
           <div className="c-form__buttons">
             <a className="c-form__cancel-button" onClick={this.handleCancel}>
               <i className="fa fa-times-circle"/><span>Cancel</span>
             </a>
             <a className="c-button c-form__submit-button" onClick={this.handleSubmit}>
               <i className="fa fa-download"/><span>Export</span>
             </a>
           </div>
         </div>
       </div>
      }
    </div>;
  }
}

const
  mapStateToProps = state => {
    return {
      data_set: state.graphs.data_set,
      short_future: state.graphs.short_future
    };
  };
const
  mapDispatchToProps = dispatch => {
    return {
      dispatch: dispatch
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(ExportForm);



// WEBPACK FOOTER //
// ./src/components/ExportForm.js